import videojs from "video.js";
const Component = videojs.getComponent('Component');

export class timeBanners extends Component {
    createEl() {
        return videojs.dom.createEl('div', {
            className: 'vjs-time-banners'
        });
    }
}

export const initTimeBanners = (player, section) => {

    const timeBanners = section.querySelector('ul.time-banners');

	if ( !timeBanners ) {
		return;
	}

	let timeCodes = [];

	timeBanners.children.forEach(item => {
		timeCodes.push(item.getAttribute('data-time'));
	});

	player.addChild('timeBanners');
	
	player.getChild('timeBanners').el_.innerHTML = `
		${timeBanners.outerHTML}
	`;
	
	const timeBannersItems = player.getChild('timeBanners').el_.querySelectorAll('li');
	timeBanners.remove();

	player.on("timeupdate", function() {
		timeCodes.forEach( (item, index) => {

			if ( +item === Math.ceil(player.cache_.currentTime) ) {
				player.getChild('timeBanners').el_.classList.add('active');
				timeBannersItems[index].classList.add('active');
			}

			if ( +item + 10 === Math.ceil(player.cache_.currentTime) ) {
				player.getChild('timeBanners').el_.classList.remove('active');
				timeBannersItems[index].classList.remove('active');
			}
		})
	});

	player.on("seeked", function() {
		timeBannersItems.forEach( item => {
			player.getChild('timeBanners').el_.classList.remove('active');
			item.classList.remove('active');
		})
	});
}